import { Outlet, Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import NavMenu from './NavMenu';
import VersionHighlight from './VersionHighlight';
import MessageBanner from './MessageBanner';

// Determine the environment from your environment variable
const env = process.env.REACT_APP_VERCEL_ENV;
const envBannerSettings = {
  development: { text: 'Development', backgroundColor: '#FFA500' },
  beta: { text: 'Beta', backgroundColor: '#007bff' },
  preview: { text: 'Preview', backgroundColor: '#6f42c1' },
};
const banner = envBannerSettings[env];

const Layout = ({
  user,
  onSignOut = () => {},
  children,
  containerClassName = 'p-4',
  containerStyle,
  contentStyle,
  wrapperStyle,
  showVersionHighlight = true,
}) => {
  return (
    <div className='bg-light' style={{ minHeight: '100vh', ...wrapperStyle }}>
      {banner && (
        <div
          style={{
            backgroundColor: banner.backgroundColor,
            color: '#fff',
            textAlign: 'center',
            padding: '4px 0',
            fontSize: '0.9rem',
            textTransform: 'uppercase',
            fontWeight: 600,
            letterSpacing: '0.05rem',
          }}
        >
          {banner.text}
        </div>
      )}
      <MessageBanner />
      <Container className={containerClassName} style={{ maxWidth: '768px', ...containerStyle }}>
        <Row className='mt-3 mb-3 mx-0 align-items-center'>
          <div className='d-flex align-items-center justify-content-center position-relative w-100'>
            <div
              className='position-absolute start-0 d-flex align-items-center justify-content-start'
              style={{ paddingRight: 8 }}
            >
              <div style={{ width: 36, height: 36 }} />
            </div>
            <nav className='flex-grow-1 d-flex justify-content-center'>
              <Link to='/' style={{ textDecoration: 'none' }}>
                <h1 className='header mb-0 text-center'>Lexio</h1>
              </Link>
            </nav>
            <div
              className='position-absolute end-0 d-flex align-items-center justify-content-end'
              style={{ paddingLeft: 8 }}
            >
              <NavMenu user={user} onSignOut={onSignOut} />
            </div>
          </div>
        </Row>
        <Row className='py-2' style={contentStyle}>
          {children ?? <Outlet />}
        </Row>
        {showVersionHighlight && (
          <Row className='pt-2'>
            <VersionHighlight />
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Layout;
